<svg style="background:var(--anatomy-gray-100); padding: 50px 10px" height="48" viewBox="0 0 200 48">
  <rect id="Placement_Area" data-name="Placement Area" width="200" height="48" fill="red" opacity="0"/>
  <g id="Alert">
    <rect id="Background" width="200" height="48" rx="4" fill="var(--anatomy-gray-200)" stroke="var(--anatomy-gray-400)" stroke-width="1"/>
    <circle id="Icon_Background" cx="8" cy="8" r="8" transform="translate(8 16)" fill="var(--anatomy-gray-600)"/>
    <text id="Icon" transform="translate(16 28)" fill="white" font-size="12" font-family="var(--anatomy-font)" font-weight="700" text-anchor="middle"><tspan x="0" y="0">i</tspan></text>
    <rect id="Text_Line_1" x="32" y="14" width="140" height="8" rx="2" fill="var(--anatomy-gray-500)"/>
    <rect id="Text_Line_2" x="32" y="26" width="110" height="8" rx="2" fill="var(--anatomy-gray-400)"/>
  </g>
</svg>
